import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  name: [
    {...makeRule()},
  ],
}

export let formRules = {
  user_id: [
    {...makeRule('请选择用户名', 'integer', 'blur', true), min: 1},
  ],
  department_id: [
    {...makeRule('请选择部门', 'integer', 'blur', true), min: 1},
  ],
  department_job_id: [
    {...makeRule('请选择岗位', 'integer', 'blur', true), min: 1},
  ],
  realname: [
    {...makeRule('请输入员工姓名'), min: 1},
  ],
  first_approver: [
    {...makeRule('请选择一级审批人', 'integer', 'blur', true), min: 1},
  ],
  second_approver: [
    {...makeRule('请选择二级审批人', 'integer', 'blur', true), min: 1},
  ],
  third_approver: [
    {...makeRule('请选择三级审批人', 'integer', 'blur', true), min: 1},
  ],
  fourth_approver: [
    {...makeRule('请选择四级审批人', 'integer', 'blur', true), min: 1},
  ],
  name: [
    {...makeRule('账户名称不能为空', 'string', 'blur', true)},
  ],
  bank_account: [
    {required: true, message: '银行账号不能为空', trigger: 'blur'},
  ],
  bank: [
    {required: true, message: '开户银行支行不能为空', trigger: 'blur'},
  ],
  bank_headquarters: [
    {required: true, message: '开户银行总行不能为空', trigger: 'blur'},
  ],
}



// WEBPACK FOOTER //
// ./src/views/user-bank-account/user-bank-account.rules.js